import FinancialActionType from '../actionTypes/FinancialActionType';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case FinancialActionType.UPDATE:
      return { ...state, billUpdated: action.billUpdated };
    case FinancialActionType.CREATE:
      return { ...state, billCreated: action.billCreated };
    case FinancialActionType.DELETE:
      return { ...state, billDeleted: action.billDeleted };
    default:
      return state;
  }
};
